var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "caption soli-grey" }, [
    _vm._v(
      "\n    " +
        _vm._s(_vm.lesson.teacher.name) +
        " ·\n    " +
        _vm._s(_vm.lesson.online ? "Online" : _vm.lesson.room.title) +
        " ·\n    " +
        _vm._s(_vm.lesson.duration) +
        " min\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }